
<div>
  <ProgressBar :value="currentStepIndex + 1" :max="steps.length" :content="`Step ${currentStepIndex} of ${steps.length}`" />
  <div :class="contentClass">
    <Breadcrumb
      v-if="currentStepIndex > 0 && !isEditStep"
      :header="backButtonLabel"
      :isButton="true"
      class="mt-16 mb-24 md:mt-0"
      @click="navigateToPreviousStep"
    />
    <div :key="draftDataCacheKey">
      <keep-alive>
        <router-view :navigateToNextStep="navigateToNextStep" :stepsData="stepsData" :draft="draftData" />
      </keep-alive>
    </div>
  </div>
</div>
